module.exports = __webpack_public_path__ + "static/img/1_3_3.8eb3c4ab.jpg";